/**
 * @Description 逐字展示组件，2s内将一行文字展示完毕
 */
import { FC, useEffect, useState } from 'react';

interface TypewriterTextProps {
  text: string;
  duration?: number; // 总展示时长(ms)，默认1000
  className?: string;
  onDone?: () => void; // 展示完毕回调
}

const TypewriterText: FC<TypewriterTextProps> = ({ text, duration = 1000, className, onDone }) => {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    if (!text) return;
    setDisplayed('');
    const len = text.length;
    const interval = duration / len;
    let i = 0;
    const timer = setInterval(() => {
      i++;
      setDisplayed(text.slice(0, i));
      if (i >= len) {
        clearInterval(timer);
        onDone?.();
      }
    }, interval);
    return () => clearInterval(timer);
  }, [text]);

  return <span className={className}>{displayed}</span>;
};

export default TypewriterText;
